import React, { useRef, useEffect, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { clientProofMessage } from '../lib/clientProof';

export default function GoogleLoginButton() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const [buttonWidth, setButtonWidth] = useState(320);

  useEffect(() => {
    // Measure parent container to match button width to form fields
    const updateWidth = () => {
      if (containerRef.current) {
        const w = containerRef.current.offsetWidth;
        if (w > 0) setButtonWidth(w);
      }
    };
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const handleSuccess = async (credentialResponse) => {
    try {
      const user = await loginWithGoogle(credentialResponse.credential);
      console.log('Google login successful:', user);
      navigate('/dashboard');
    } catch (error) {
      if (error?.response?.data?.detail?.code === 'existing_account_use_invite') {
        navigate('/login?error=existing_account_use_invite');
        return;
      }
      console.error('Google login failed:', error);
      alert(clientProofMessage(error) || 'Google sign-in failed. Please try again.');
    }
  };

  const handleError = () => {
    console.error('Google Sign-In failed');
    alert('Google sign-in failed. Please try again.');
  };

  return (
    <div ref={containerRef} style={{ margin: '20px 0' }}>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        useOneTap={false}
        text="signin_with"
        shape="rectangular"
        size="large"
        width={buttonWidth}
      />
    </div>
  );
}
